function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  transform: "translate(0, 14)",
  stroke: "var(--primary-color, #000)"
}, /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m31.68 15.029c0 4.8601-0.88 7.04-6.16 7.04h-14.08c-2.045 0-1.76-2.2404-1.76-4.4 0-4.8601 4.1369-8.8 9.24-8.8h9.24 19.36c0.27688 0 3.96-3.96 3.96-3.96h3.52s-5.0131 6.5964-5.72 7.48c-6.16 0.88-13.2 1.76-17.6 2.64z",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "m17.527 6.852h8.0667c0.44689 0 0.80667 0.3598 0.80667 0.8067v1.21h-9.68v-1.21c0-0.4469 0.35977-0.8067 0.80667-0.8067z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.824 10.629h4.4c0.97504 0 1.76 0.785 1.76 1.76v3.52c0 0.975-0.78496 1.76-1.76 1.76h-4.4c-0.97504 0-1.76-0.785-1.76-1.76v-3.52c0-0.975 0.78496-1.76 1.76-1.76z"
})), /*#__PURE__*/React.createElement("g", {
  strokeWidth: "1px"
}, /*#__PURE__*/React.createElement("path", {
  d: "m17.6 8.8688v7.04c0 1.408-0.88 1.76-1.76 1.76h-6.16"
}), /*#__PURE__*/React.createElement("path", {
  d: "m23.76 22.069v4.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m12.32 22.069-5.28 4.4"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4.4 22.949s1.3282 2.8641 2.64 3.52h28.16"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.56 4.4688v2.64"
}), /*#__PURE__*/React.createElement("path", {
  d: "m0 4.4688h43.12"
})));

var SvgHelicopter = function SvgHelicopter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelicopter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Helicopter.61dc4a15.svg";
export { ForwardRef as ReactComponent };